import React, { Children, Component } from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import compose from "recompose/compose";
import getDefaultValues from "./getDefaultValues";
import { FormField, Responsive, Toolbar } from "admin-on-rest";
//import { Values } from "redux-form-website-template";

class OlaForm extends Component {
  handleSubmitWithRedirect = (redirect = this.props.redirect) =>
    this.props.handleSubmit(values =>{
      if(values.marketer_id ===  null){
        values.marketer_id = 0;
      }
      this.props.save(values, redirect)
    });

  render() {
    const {
      children,
      invalid,
      record,
      resource,
      basePath,
      submitOnEnter,
      toolbar
    } = this.props;
    return (
      <div>
        <form className="simple-form">
          <Responsive
            small={
              <div style={{ padding: "3em 1em 6em 1em" }}>
                {Children.map(
                  children,
                  input =>
                  input && (
                    <div
                      key={input.props.source}
                      className={`aor-input-${input.props.source}`}
                      style={input.props.style}
                    >
                      <FormField
                        input={input}
                        resource={resource}
                        record={record}
                        basePath={basePath}
                      />
                    </div>
                  )
                )}
              </div>
            }
            medium={
              <div style={{ padding: "0 1em 1em 1em" }}>
                {Children.map(
                  children,
                  input =>
                  input && (
                    <div
                      key={input.props.source}
                      className={`aor-input-${input.props.source}`}
                      style={input.props.style}
                    >
                      <FormField
                        input={input}
                        resource={resource}
                        record={record}
                        basePath={basePath}
                      />
                    </div>
                  )
                )}
              </div>
            }
          />
          {toolbar &&
            React.cloneElement(toolbar, {
              handleSubmitWithRedirect: this.handleSubmitWithRedirect,
              invalid,
              submitOnEnter
            })}
        </form>
      </div>
    );
  }
}
/*
<div style={{width:400}}>
		<Values form="record-form" />
</div>
*/

OlaForm.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  handleSubmit: PropTypes.func, // passed by redux-form
  invalid: PropTypes.bool,
  record: PropTypes.object,
  resource: PropTypes.string,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  save: PropTypes.func, // the handler defined in the parent, which triggers the REST submission
  submitOnEnter: PropTypes.bool,
  toolbar: PropTypes.element,
  validate: PropTypes.func
};

OlaForm.defaultProps = {
  submitOnEnter: false,
  toolbar: <Toolbar />
};

const enhance = compose(
  connect((state, props) => ({
    initialValues: getDefaultValues(state, props)
  })),
  reduxForm({
    form: "record-form",
    enableReinitialize: true
  })
);

export default enhance(OlaForm);



// WEBPACK FOOTER //
// ./src/components/form/OlaForm.js